import CoordinatesInput from './CoordinatesInput';

export default CoordinatesInput;
